export const dataHome=[
    {
        id:"0",
        title:"fruits et légumes dans des assiettes en plein air",
        img_main:"home-naturo.jpg",
        img_illustration:[],
        large_description:`<h2>LA NATUROPATHIE OU LE CHEMIN VERS LA NATURE</h2>
        <p>
        La naturopathie existe depuis des millénaires à travers le monde pour apaiser les maux plus ou moins ancrés.
        ‍<br />
        ‍<br />
        Le naturopathe cherche à <b>retrouver et préserver l’équilibre</b> du corps ainsi que de l'esprit en utilisant des méthodes naturelles.
        ‍‍<br />
        ‍<br />
        La consultation vous offre ainsi la possibilité de trouver la cause profonde du déséquilibre et des dysfonctionnements auxquels votre corps fait face.
        ‍‍<br />
        ‍<br />
        Chaque entretien est <b>personnalisé</b> et les conseils apportés respectent votre mode de vie.
        ‍‍<br />
        ‍<br />
        Le but est de vous proposer un suivi en parfaite adéquation avec votre tempérament et vos envies.
        Ceci dans le <b>respect, l'écoute et la bienveillance.</b> 
        ‍‍<br />
        ‍<br />
        Votre programme intègre des recommandations en termes d'hygiène alimentaire, d'activités physiques et de gestion émotionnelle.
        ‍‍<br />
        ‍<br />
        En fonction des besoins, d'autres solutions naturelles seront suggérées :
            <ul><li>- Fleurs de Bach </li>
                <li>- Huiles essentielles</li>
                <li>- Bourgeons </li>
                <li>- Produits de la ruche</li>
            </ul>
        </p>`,
        tarif:``
    },
    {
        id:"1",
        title:"portrait de famille de Cindy et ses deux enfants",
        img_main:"profil-home.jpg",
        img_illustration:[],
        large_description:`<h2>MON PARCOURS</h2>
        <p>
        Passionnée par la naturopathie depuis de nombreuses années, c'est après la naissance de mes deux enfants que j'ai décidé d'en faire mon métier à part entière.
        ‍<br />
        ‍<br /> 
        <b>Respect, empathie et discrétion</b> font partie intégrante de mes consultations, le tout dans un environnement bienveillant. 
        ‍<br />
        ‍<br /> 
        Ma mission en tant que naturopathe est de vous aider à améliorer votre santé grâce à des <b>techniques naturelles et ancestrales</b> en tenant compte de votre tempérament et de votre mode de vie.
        ‍<br />
        ‍<br /> 
        La dimension émotionnelle est essentielle dans mon approche naturopathique. C'est pour cela que je me suis formée auprès de l'<b>Institut du Docteur Edward Bach</b> afin de vous proposer des consultations en gestion des émotions grâce aux 38 elixirs floraux.
        ‍<br />
        ‍<br /> 
        Je me suis découvert un réel intérêt pour les <b>massages bien-être</b> qui en plus d'apporter un effet de détente, favorisent une meilleure circulation des fluides et un équilibre énergétique certain. 
        ‍<br />
        ‍<br /> 
        J'ai donc décidé de me former auprès de différents organismes réputés afin de vous offrir une expérience unique en la matière.
        ‍<br />
        ‍<br /> 
        <b>Massage drainant méthode Vodder, Belly Revolution®, massage des 5 Continents®, massage du visage SKINTAO EXCELLENCE® et massage relaxant du dos</b> vous attendent dans un espace dédié et propice à la détente.
        ‍‍<br />
        ‍<br /> 
         Au plaisir de vous rencontrer.
         </p>`,
        tarif:``
    }
]